import { Form, Formik } from "formik";
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import AddButton, { ApproveButton } from "../../buttons/button";
import InputField from "../../forms/input-field";
import TabsComponent from "../../helper-components/tabs-component";

import { useDispatch } from "react-redux";
import { StorePaymentCreateAction } from "../../../redux/actions/store-action";
import { api } from "../../../redux/apis/api";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import SelectField from "../../forms/select-field";
import StorePayerInfoTab from "./payer-info";
import StorePayeeInfoTab from "./payee-info";
import StoreGstInfoTab from "./gst-info";
import StoreRemarksInfoTab from "./remarks-info";
import StorePaymentHistoryTab from "./payment-history";
import ImageField from "../../forms/images-field";

const StorePaymentTab = ({
  id,
  setStoreData,
  storeData,
  initialValue,
  permissionFn = () => {},
  disabled = false,
}) => {
  const [currentTab, setCurrentTab] = useState("Payer Info");
  const [accountDetails, setAccountDetails] = useState(null);
  const [storeTypeMap, setStoreTypeMap] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    api
      .get("/fofo/storeAccountDetails/getAll")
      .then((res) => {
        const first = res.data?.data?.[0];
        if (first) setAccountDetails(first);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    api
      .get("/fofo/storeType/getAll")
      .then((res) => {
        const list = res.data?.data ?? [];
        const map = {};
        list.forEach((t) => { map[t.store_type] = t; });
        setStoreTypeMap(map);
      })
      .catch(() => {});
  }, []);

  const franchiseFee =
    storeData?.address?.franchise_fee ??
    storeTypeMap[storeData?.address?.store_type]?.franchidse_fee ??
    "";

  const initialValues = {
    store_id: id ?? null,
    is_payment_terms_approve: initialValue?.is_payment_terms_approve ?? false,
    store_type: initialValue?.store_type ?? "",
    total_amount: initialValue?.total_amount ?? franchiseFee ?? "",
    total_paid: initialValue?.total_paid ?? "",
    amount_to_be_paid: initialValue?.amount_to_be_paid ?? "",
    payment_method: initialValue?.payment_method ?? "",
    payment_amount: initialValue?.payment_amount ?? null,
    transaction_id: initialValue?.transaction_id ?? "",
    payment_status: initialValue?.payment_status ?? "",
    payment_recevie_time: initialValue?.payment_recevie_time ?? null,
    payment_receipt: initialValue?.payment_receipt ?? "",
    payment_remarks: initialValue?.payment_remarks ?? "",
    payer_name_as_per_bank: initialValue?.payer_name_as_per_bank ?? "",
    payer_bank_name: initialValue?.payer_bank_name ?? "",
    payer_bank_account_no: initialValue?.payer_bank_account_no ?? "",
    payer_remaining_amount: initialValue?.payer_remaining_amount ?? "",
    payee_name_as_per_bank: initialValue?.payee_name_as_per_bank ?? accountDetails?.account_name ?? "",
    payee_bank_name: initialValue?.payee_bank_name ?? accountDetails?.bank_name ?? "",
    payee_bank_account_no: initialValue?.payee_bank_account_no ?? accountDetails?.account_number ?? "",
    isfc_code: initialValue?.isfc_code ?? accountDetails?.isfc_code ?? "",
    extra_payee: initialValue?.extra_payee ?? "",
  };

  const validationSchema = Yup.object().shape({
    payer_name_as_per_bank: Yup.string().required("Payer name is required"),
    payer_bank_name: Yup.string().required("Bank name is required"),
    payer_bank_account_no: Yup.string()
      .required("Bank account number is required")
      .matches(/^[0-9]{9,18}$/, "Invalid bank account number"),
    payer_remaining_amount: Yup.number()
      .required("Remaining amount is required")
      .positive("Remaining amount must be positive"),
    payee_name_as_per_bank: Yup.string().required("Payee name is required"),
    payee_bank_name: Yup.string().required("Bank name is required"),
    payee_bank_account_no: Yup.string()
      .required("Bank account number is required")
      .matches(/^[0-9]{9,18}$/, "Invalid bank account number"),
    isfc_code: Yup.string().required("IFSC code is required"),
    extra_payee: Yup.string().required("Required"), // No validation, optional field
    gst_number: Yup.string()
      .required("GST number is required")
      .matches(
        /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})?$/,
        "Invalid GST number"
      ),
  });

  const onSubmit = (values) => {
    if (!id) {
      errorToast("Please save Store Details first");
      return;
    }
    const isTransactionOptional = ["cheque", "dd"].includes(values.payment_method);
    if (!isTransactionOptional && !values.transaction_id) {
      errorToast("Transaction ID is required");
      return;
    }
    if (!values.payment_amount) {
      errorToast("Payment Amount is required");
      return;
    }
    const payload = {
      store_id: id,
      transaction_id: isTransactionOptional ? 1 : values.transaction_id,
      payment_amount: values.payment_amount,
      payment_method: values.payment_method,
      payment_status: values.payment_status,
      payment_remarks: values.payment_remarks,
      payment_receipt: values.payment_receipt,
      payer_name_as_per_bank: values.payer_name_as_per_bank,
      payer_bank_name: values.payer_bank_name,
      payer_bank_account_no: values.payer_bank_account_no,
      isfc_code: values.isfc_code,
    };
    dispatch(StorePaymentCreateAction(payload, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setStoreData({
      ...storeData,
      payment: data?.data,
    });
    successToast(data?.data?.message);
  };
  const onError = (data) => {
    errorToast(data?.data?.message);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      // validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, isSubmitting, errors, submitForm }) => {
        
        
        return (
          <Form style={{ height: "calc(100% - 5rem)" }} className="pt-5">
            <div className="flex flex-col justify-between h-full ">
              <div>
                <div className="w-full 2xl:w-[35%] lg:w-[60%] px-5 xl:px-10">
                  <InputField
                    isDisabled={disabled}
                    type="text"
                    name="store_type"
                    placeholder="Enter Store Type"
                    label="Store Type"
                    // isRequired={true}
                    labelWidth="11rem"
                  />
                  <InputField
                    isDisabled={true}
                    type="number"
                    name="total_amount"
                    placeholder="Auto-filled from Franchise Fee"
                    label="Total Amount"
                    labelWidth="11rem"
                  />
                  <InputField
                    isDisabled={disabled}
                    type="number"
                    name="total_paid"
                    placeholder="Enter Total Paid"
                    label="Total Paid"
                    labelWidth="11rem"
                    handleChange={(e, field) => {
                      const totalPaid = parseFloat(e.target.value) || 0;
                      const totalAmount = parseFloat(storeData?.address?.franchise_fee ?? values.total_amount) || 0;
                      if (totalPaid > totalAmount) {
                        errorToast("Total Paid cannot exceed Total Amount");
                        return;
                      }
                      field.onChange(e);
                      setFieldValue("amount_to_be_paid", Math.max(totalAmount - totalPaid, 0));
                    }}
                  />
                  <InputField
                    isDisabled={true}
                    type="number"
                    name="amount_to_be_paid"
                    placeholder="Auto-calculated"
                    label="Amount to be Paid"
                    labelWidth="11rem"
                  />
                  <SelectField
                    isDisabled={disabled}
                    placeholder={"Select payment method"}
                    options={paymentTypeList}
                    label={"Select Payment Method"}
                    id={"payment_method"}
                    name="payment_method"
                    isSearchable={true}
                    errMsgContainerClass="ps-2"
                    labelWidth="11rem"
                  />
                  <InputField
                    isDisabled={disabled}
                    type="number"
                    name="payment_amount"
                    placeholder="Enter Payment Amount"
                    label="Payment Amount"
                    labelWidth="11rem"
                  />
                  <InputField
                    isDisabled={disabled}
                    type="text"
                    name="transaction_id"
                    placeholder="Enter Transaction ID"
                    label="Transaction ID"
                    labelWidth="11rem"
                  />
                  <SelectField
                    isDisabled={disabled}
                    placeholder="Select Payment Status"
                    options={paymentStatusList}
                    label="Payment Status"
                    id="payment_status"
                    name="payment_status"
                    labelWidth="11rem"
                  />
                  <InputField
                    isDisabled={disabled}
                    type="text"
                    name="payment_remarks"
                    placeholder="Enter Payment Remarks"
                    label="Payment Remarks"
                    labelWidth="11rem"
                  />
                  <InputField
                    isDisabled={disabled}
                    type="datetime-local"
                    name="payment_recevie_time"
                    placeholder="Enter Payment Receive Time"
                    label="Payment Receive Time"
                    labelWidth="11rem"
                  />
                  {/* <InputField
                    type="date"
                    name="addres_remarks"
                    placeholder=""
                    label="Payment Receive Date"
                    labelWidth="11rem"
                  /> */}

                  <ImageField
                    isDisabled={disabled}
                    label="Chalan Receipt"
                    isRequired={false}
                    labelWidth="11rem"
                    name="payment_receipt"
                    mainLabel="Payment Receipt"
                  />

                  {id && (
                    <div className="flex gap-5 my-5">
                      <ApproveButton
                        onclkFn={async () => {
                          await setFieldValue("is_payment_terms_approve", true);
                          submitForm();
                        }}
                        type="button"
                        text={
                          values?.is_payment_terms_approve
                            ? "Approved"
                            : "Approve"
                        }
                      />
                    </div>
                  )}
                </div>
                <TabsComponent
                  handleClickfn={(item) => {
                    setCurrentTab(item);
                  }}
                  itemTabs={itemTabs}
                  setCurrentTab={setCurrentTab}
                  currentTab={currentTab}
                />
                {currentTab === "Payer Info" && (
                  <StorePayerInfoTab disabled={disabled} />
                )}
                {currentTab === "Payee Info" && (
                  <StorePayeeInfoTab disabled={disabled} />
                )}
                {currentTab === "Gst Details" && (
                  <StoreGstInfoTab disabled={disabled} />
                )}
                {currentTab === "Remarks" && (
                  <StoreRemarksInfoTab disabled={disabled} />
                )}
                {currentTab === "Payment History" && (
                  <StorePaymentHistoryTab disabled={disabled} />
                )}
              </div>

              {!disabled && (
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={() => {
                      if (Object.keys(errors).length !== 0) {
                        const currentIndex = itemTabs.indexOf(currentTab);
                        let nextTab;

                        if (currentIndex !== -1) {
                          // Go to the next tab based on the current tab index
                          nextTab =
                            currentIndex === itemTabs.length - 1
                              ? itemTabs[0] // Loop back to the first tab if the last tab is reached
                              : itemTabs[currentIndex + 1];

                          setCurrentTab(nextTab);
                        }
                      }
                    }}
                    prefixIcon={false}
                    text="Save"
                    type="submit"
                  />
                </div>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default StorePaymentTab;

const paymentTypeList = [
  { label: "Online", value: "online" },
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "Cheque", value: "cheque" },
  { label: "DD", value: "dd" },
];
const paymentStatusList = [
  { label: "Pending", value: "pending" },
  { label: "Paid", value: "paid" },
  { label: "Partial", value: "partial" },
];
const itemTabs = ["Payer Info", "Payee Info", "Gst Details", "Remarks", "Payment History"];
